import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SecurityLayout from "./SecurityLayout";

interface RegisterLayoutProps {
	children: React.ReactNode;
}

const RegisterLayout = (props: RegisterLayoutProps) => {
	const { t } = useTranslation();

	return (
		<SecurityLayout>
			<div className="layout-account layout-login layout-login-center">
				<div className="layout-login-box">
					<img className="form-login-dots" src="/graphics/login/dots-yellow.svg" alt="Yellow dots" />

					<div className="form-login">
						<Link to={"/"}>
							<img alt="GoPOS Logo" className="logo-img" src={"/graphics/goaccounts-logo-b.svg"} />
						</Link>
						{props.children}
					</div>
				</div>
				<div className="login-footer">
					<ul className="list-inline">
						<li className="list-inline-item">
							<a href="https://www.gopos.pl">© GoPOS</a>
						</li>
						<li className="list-inline-item">
							<a href="https://www.gopos.pl/contact">{t("modules.security.field.contact.title")}</a>
						</li>
						<li className="list-inline-item">
							<a href="https://www.gopos.pl/privacy-policy">{t("modules.security.field.rules.title")}</a>
						</li>
					</ul>
				</div>
			</div>
		</SecurityLayout>
	);
};

export default RegisterLayout;
